var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("IndexSynchronization.add.Basic")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.tryCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            inline: "",
            "label-width": "140px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("IndexSynchronization.Code"),
                prop: "syncConfCode",
              },
            },
            [
              _c("BjInput", {
                attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, placeholder: "" },
                model: {
                  value: _vm.form.syncConfCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "syncConfCode", $$v)
                  },
                  expression: "form.syncConfCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("IndexSynchronization.Index"),
                prop: "indexCode",
              },
            },
            [_c("bj-code-select", { on: { change: _vm.changeIndexCode } })],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("IndexSynchronization.Description"),
                prop: "remark",
              },
            },
            [
              _c("BjInput", {
                attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, placeholder: "" },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("IndexSynchronization.type"),
                prop: "sourceFromType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "full-width",
                  attrs: { placeholder: _vm.$t("chooseText"), clearable: "" },
                  model: {
                    value: _vm.form.sourceFromType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "sourceFromType", $$v)
                    },
                    expression: "form.sourceFromType",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "INTERFACE", value: "INTERFACE" },
                  }),
                  _c("el-option", { attrs: { label: "DB", value: "DB" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("IndexSynchronization.Data"),
                prop: "sourceFromCode",
              },
            },
            [
              _c("BjInput", {
                attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, placeholder: "" },
                model: {
                  value: _vm.form.sourceFromCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sourceFromCode", $$v)
                  },
                  expression: "form.sourceFromCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("IndexSynchronization.add.Data"),
                prop: "sourceFromDetailCode",
              },
            },
            [
              _c("BjInput", {
                attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, placeholder: "" },
                model: {
                  value: _vm.form.sourceFromDetailCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sourceFromDetailCode", $$v)
                  },
                  expression: "form.sourceFromDetailCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("IndexSynchronization.add.Whether"),
                prop: "isRecord",
              },
            },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.isRecord,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "isRecord", $$v)
                  },
                  expression: "form.isRecord",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("IndexSynchronization.add.Command"),
                        prop: "commandContent",
                      },
                    },
                    [
                      _c("BjInput", {
                        staticStyle: { width: "600px" },
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          type: "textarea",
                        },
                        model: {
                          value: _vm.form.commandContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "commandContent", $$v)
                          },
                          expression: "form.commandContent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        [
          _vm._v(_vm._s(_vm.$t("IndexSynchronization.add.field")) + " "),
          _c(
            "template",
            { slot: "button" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                [_vm._v(_vm._s(_vm.$t("addText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-table",
        { attrs: { border: "", data: _vm.form.indexFieldSyncConfList } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("IndexSynchronization.add.name"),
              align: "center",
              prop: "fieldName",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                      },
                      model: {
                        value: scope.row.fieldName,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "fieldName", $$v)
                        },
                        expression: "scope.row.fieldName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("IndexSynchronization.add.Mapping"),
              align: "center",
              prop: "fieldMapping",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          remote: "",
                          "reserve-keyword": "",
                          placeholder: _vm.$t("inputText"),
                          "remote-method": _vm.remoteMethodFieldName,
                          loading: _vm.loading,
                        },
                        on: {
                          change: _vm.changeFieldName,
                          focus: function ($event) {
                            return _vm.changeFocus($event, scope)
                          },
                        },
                        model: {
                          value: scope.row.fieldMapping,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "fieldMapping", $$v)
                          },
                          expression: "scope.row.fieldMapping",
                        },
                      },
                      _vm._l(_vm.fieldNameListOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("IndexSynchronization.add.Operation"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", icon: "el-icon-delete" },
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(scope.$index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt20", staticStyle: { "text-align": "right" } },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.form.pageNun,
              "page-sizes": _vm.PAGE_SIZES,
              "page-size": _vm.form.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.form.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }